import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/auth";

const Init = () => {
  const auth = useRecoilValue(authState);

  useEffect(() => {
    if (auth.user_token_id !== 3781 && auth.user_id !== 1301) {
      setTimeout(() => {
        window.location.replace("/master");
      }, 5000);
    }
  }, [auth]);

  return (
    <div>
      <img
        src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
        width={"100%"}
        alt="로딩이미지"
      />
    </div>
  );
};
export default Init;
